exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page .menu[data-v-3b8fa8aa]{display:grid;grid-template-columns:1fr 1fr;grid-row-gap:15px;grid-column-gap:15px}.page .menu a[data-v-3b8fa8aa]{text-decoration:none;color:#333;border:1px solid #999;border-radius:8px;display:flex;justify-content:center;align-items:center;text-align:center;height:100px;text-transform:uppercase;font-size:14px;padding:0 20px}.page .menu a[data-v-3b8fa8aa]:active{background-color:#eee}.page .menu div[data-v-3b8fa8aa]{border:1px solid #999;padding:15px}.page .menu div h3[data-v-3b8fa8aa]{margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3b8fa8aa","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Home.vue
// module id = 200
// module chunks = 0